import { Form } from "react-bootstrap";
import { CommonContentMessage } from "../../types";
import {
  EditMessageComponent,
  EditMessageComponentProps,
  EventBody,
  MessageComponent,
  MessageComponentProps,
} from "./Message";

const ContentMessage: MessageComponent<CommonContentMessage> = ({
  message,
}: MessageComponentProps<CommonContentMessage>) => {
  return <EventBody>{message.content as string}</EventBody>;
};

export const EditContentMessage: EditMessageComponent<CommonContentMessage> = ({
  message,
  onGameEventMessageChange,
}: EditMessageComponentProps<CommonContentMessage>) => {
  return (
    <EventBody>
      <Form.Control
        style={{ height: "100px" }}
        as="textarea"
        value={message.content}
        onChange={(e) =>
          onGameEventMessageChange({
            ...message,
            content: e.target.value,
          })
        }
      />
    </EventBody>
  );
};

export default ContentMessage;
